import { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { GET_PROGRAM_BY_ID, PROGRAM_ENDPOINT, ProgramFormStepMapper, ProgramFormSteps } from '../../../../constants/program.constants';
import ProgramInfo from './program-info';
import ProgramSchedule from './program-schedule';
import ProgramAdditionalInfo from './program-additional-info';
import ProgramTermsAgreements from './program-terms-agreement';
import ProgramFees from './program-fee';
import { getSetOrgInfo, getUserInfo } from '../../../../utils/user-info';
import axios from 'axios';
import ErrorBanner from '../../../../shared/error-banner/error-banner';


function ProgramForm(props) {
    const userInfo = getUserInfo();
    const orgInfo = getSetOrgInfo();
    const { action, program_id } = useParams();
    const [programDetails, setProgramDetails] = useState();
    const [programLoader, setProgramLoader] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();
    const [stepCounter, setStepCounter] = useState(0);

    const stepFields = [
        ["title"],
        ["schedule.start_date", "schedule.recurrence_type", "schedule.recurrence_interval", 'schedule.recurs_on_sunday',
            'schedule.recurs_on_monday',
            'schedule.recurs_on_tuesday',
            'schedule.recurs_on_wednesday',
            'schedule.recurs_on_thursday',
            'schedule.recurs_on_friday',
            'schedule.recurs_on_saturday',
            'schedule.recurrence_interval',
            'schedule.recurrence_pattern_type',
            'schedule.recurrence_day_of_month',
            'schedule.recurrence_week_of_month',
            'schedule.recurrence_day_name',
            'schedule.end_date'
        ],
        ['registrant', 'participant', 'registration_open_date', 'registration_close_date', 'max_capacity'],
        ['terms_page_url', 'additional_notification_email'],
        ['pricing.fee_type', 'pricing.fee_calculation', 'pricing.enable_one_time_payment', 'pricing.enable_monthly_payment', 'pricing.payment_settings.recurring_payment_end_date', 'pricing.one_time_amount', 'pricing.monthly_amount', 'pricing.additional_participant_one_time', 'pricing.additional_participant_monthly']
    ]
    const methods = useForm({
        defaultValues: {
            masjid_id: userInfo?.masjid_id,
            currency: orgInfo?.currency,
            program_status: 'active',
            schedule: {
                recurrence_type: 'daily',
                recurrence_interval: 2,
                recurrence_day_of_month: 1,
                recurrence_pattern_type: 'day_of_month',
            },
            send_confirmation_email: false,
            pricing:{
                fee_type: 'free',
            fee_calculation: 'per_registration',
            enable_one_time_payment: true,
            one_time_amount: 0,
            monthly_amount: 0,
            additional_participant_one_time: 0,
            additional_participant_monthly: 0,
            ask_cover_transaction_fees: false,
            include_processing_fees_default: false,
            payment_settings: {
                default_payment_option: 'one_time',
                recurring_payment_end_type: 'program_end',
            }
            },
            main_section_label: 'Main Information',
            sub_section_label: 'Participant Information',
        }
    });
    const { register, handleSubmit, trigger, formState: { errors }, reset } = methods;
    const [currentStep, setCurrentStep] = useState('program_info');// 1 => general_info, 2. => dynamic_section, 3 => payment

    const saveProgram = (formValues) => {
        console.log(formValues)
        setProgramLoader(true);
        setErrorMessage("");
        (program_id && action === 'edit' ? axios.put(`${PROGRAM_ENDPOINT}/${program_id}`, formValues) : axios.post(PROGRAM_ENDPOINT, formValues))
        .then((res) => {
            setProgramLoader(false);
            if(res?.data?.status){
                navigate("/programs");
            }else{
                setErrorMessage(res?.data?.message);
            }

        }).catch((error) => {
            setProgramLoader(false);
            setErrorMessage(error?.response?.data?.message);
        })
    }

    const getProgramByID = () => {
        setProgramLoader(true);
        axios.get(`${GET_PROGRAM_BY_ID}${program_id}`)
        .then((res) => {
            setProgramLoader(false);
            if(res?.data?.status){
                reset(res?.data?.response);
                setProgramDetails(res?.data?.response);
            }else{
                setErrorMessage(res?.data?.message);
            }
        }).catch((error) => {
            setProgramLoader(false);
            setErrorMessage(error?.response?.data?.message);
        })
    }

    const nextStep = async () => {
        const isFormValid = await trigger(stepFields[stepCounter]);
        if (isFormValid) {
            setStepCounter(stepCounter + 1);
            setCurrentStep(ProgramFormSteps[stepCounter + 1].value);
        }
    }

    const prevStep = () => {
        setStepCounter(stepCounter - 1);
        setCurrentStep(ProgramFormSteps[(stepCounter - 1)].value);
    }

    useEffect(() => {
        if(program_id && action === 'edit'){
            getProgramByID();
        }
    }, [action, program_id])

    return (
        <>
            <FormProvider {...methods}>
                <form onSubmit={handleSubmit(saveProgram)}>
                    <div className='d-flex justify-content-between align-items-center flex-md-row flex-column'>
                        <div className='pt-2'>
                            <h5 className='font-weight-semibold text-black'>
                                {action === 'edit' ? programDetails?.title : 'Add Program'}
                            </h5>
                        </div>
                        <div>
                            <button
                            type='button'
                            onClick={() => navigate('/programs')}
                                className={`btn btn-outline-secondary mb-0 mx-2`}>
                                Cancel
                            </button>
                            {stepCounter > 0 && <button disabled={programLoader} type="button" 
                            className={`btn btn-primary mb-0 mx-2 ${programLoader ? 'button--loading position-relative ' : ''}`} onClick={prevStep}>Back</button>}
                            {stepCounter < 4 && <button disabled={programLoader} type="button" 
                            className={`btn btn-primary mb-0 mx-2 ${programLoader ? 'button--loading position-relative ' : ''}`} onClick={nextStep}>Next</button>}
                            {stepCounter === 4 && <button disabled={programLoader} type="submit" 
                            className={`btn btn-primary mb-0 mx-2 ${programLoader ? 'button--loading position-relative ' : ''}`}>Submit</button>}
                        </div>
                    </div>
                    <div className='row mt-3'>
                        <ErrorBanner 
                        onClose={() => setErrorMessage("")}
                        title={'Error occurred!'} message={errorMessage} />

                        <div className='col-12 mb-3'>
                                {/* Navigation Tabs */}
          <div style={{ 
            borderBottom: '1px solid #e5e7eb',
            display: 'flex',
            gap: '0',
                            backgroundColor: 'white',
                            border: '1px solid lightgrey',
                            borderRadius: '10px'
          }}>
            {ProgramFormSteps.map((item, index) => (
              <button
              type='button'
                key={item.value}
                onClick={action === 'edit' ? (async () => {
                    const isFormValid = await trigger();
                    if (isFormValid) {
                        setCurrentStep(item.value);
                        setStepCounter(index);
                    }
                }) : null}
                style={{
                  background: 'none',
                  border: 'none',
                  padding: '12px 20px',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: currentStep === item.value ? '#3b82f6' : '#6b7280',
                  cursor: 'pointer',
                  borderBottom: currentStep === item.value ? '3px solid #3b82f6' : '3px solid transparent',
                  marginBottom: '-1px',
                  transition: 'all 0.2s',
                  cursor: action === 'edit' ? 'pointer' : 'default'
                }}
                onMouseEnter={(e) => {
                  if (currentStep !== item.value) {
                    e.target.style.color = '#374151';
                  }
                }}
                onMouseLeave={(e) => {
                  if (currentStep !== item.value) {
                    e.target.style.color = '#6b7280';
                  }
                }}
              >
                {item.label}
              </button>
            ))}
          </div>
                        </div>
                        {/* <div className='col-xxl-3 col-md-4 col-sm-12 mb-md-0 mb-3'>
                            <div className='form-navigation'>
                                <ul className='form-navigation__list'>
                                    {
                                        ProgramFormSteps.map((item, index) => {
                                            return <li
                                                key={`program_nav_${index}`}
                                                // onClick={async () => {
                                                //     const isFormValid = await trigger();
                                                //     if (isFormValid) {
                                                //         setCurrentStep(item.value);
                                                //         setStepCounter(index);
                                                //     }
                                                // }}
                                                className={`form-navigation__item ${currentStep === item.value ? 'active' : ''}`}>{item.label}</li>
                                        })
                                    }
                                </ul>
                            </div>
                        </div> */}


                        <div className='col-xxl-12 col-12'>



                            {
                                ProgramFormStepMapper.ProgramInfo === currentStep ?
                                    <ProgramInfo /> :
                                    ProgramFormStepMapper.ProgramSchedule === currentStep ?
                                        <ProgramSchedule programID={program_id} programDetails={programDetails} /> :
                                        ProgramFormStepMapper.ProgramAdditionalInfo === currentStep ?
                                            <ProgramAdditionalInfo programID={program_id} programDetails={programDetails} /> :
                                            ProgramFormStepMapper.ProgramTermsAgreement === currentStep ?
                                                <ProgramTermsAgreements /> :
                                                ProgramFormStepMapper.ProgramFee === currentStep ?
                                                    <ProgramFees /> : ''

                            }

                        </div>

                    </div>
                </form>
            </FormProvider >
        </>
    );
}

export default ProgramForm;